import { render, staticRenderFns } from "./dialog-edit-date.vue?vue&type=template&id=10b59b01&scoped=true&"
import script from "./dialog-edit-date.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-date.vue?vue&type=script&lang=js&"
import style0 from "./dialog-edit-date.vue?vue&type=style&index=0&id=10b59b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b59b01",
  null
  
)

export default component.exports